@if (isReduced) {
  <div class="smallLoaderContainer">
    <div class="header">
      <ngx-skeleton-loader
        [theme]="{ height: '30px' }"
        count="1"
        loadingText="Loading section content"
      />
      <ngx-skeleton-loader
        [theme]="{ height: '30px', width: '65%' }"
        count="1"
        loadingText="Loading section content"
      />
    </div>
    <ngx-skeleton-loader count="2" loadingText="Loading section content" />
    <ngx-skeleton-loader
      [theme]="{ width: '60%' }"
      count="1"
      loadingText="Loading section content"
    />
  </div>
} @else {
  <div class="loaderContainer">
    <div class="header">
      <ngx-skeleton-loader
        [theme]="{ height: '30px' }"
        count="1"
        loadingText="Loading section content"
      />
      <ngx-skeleton-loader
        [theme]="{ height: '30px', width: '65%' }"
        count="1"
        loadingText="Loading section content"
      />
    </div>
    <ngx-skeleton-loader count="5" loadingText="Loading section content" />
    <ngx-skeleton-loader
      [theme]="{ width: '60%' }"
      count="1"
      loadingText="Loading section content"
    />
    <br />
    <br />
    <ngx-skeleton-loader count="4" loadingText="Loading section content" />
    <ngx-skeleton-loader
      [theme]="{ width: '40%' }"
      count="1"
      loadingText="Loading section content"
    />
  </div>
}
